import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Planilla Maestra de Cobros, Honorarios y Facturación',
    desc: 'Registro diario y mensual de sesiones · Control de autorizaciones · Planilla de facturación por OS · Seguimiento de cobros y deudas · Modelo de nota de reclamo · Registro anual de ingresos · Calculadora de arancel particular · Checklist de cierre mensual',
    value: '$9.000'
  }, {
    num: '02',
    title: 'Cuadernillo de Actividades para Casa',
    desc: '5 fichas de motricidad fina · 4 de integración sensorial · 4 de AVD y autonomía · 3 de funciones ejecutivas · 3 rutinas terapéuticas integradas (mañana, tarde y noche) · Registro semanal para que la familia reporte al TO',
    value: '$8.000'
  }, {
    num: '03',
    title: 'Kit de Evaluación Sensorial Rápida',
    desc: 'Cuestionario para padres (60 ítems · 7 sistemas) · Versión breve · Cuestionario para docentes · Protocolo de observación en primera sesión · Observación en el aula · Grilla de interpretación y perfil integrado · Ficha de devolución a familias',
    value: '$10.000'
  }, {
    num: '04',
    title: 'Guía Express de Primera Entrevista y Anamnesis',
    desc: 'Protocolo de primer contacto (teléfono y WhatsApp) · Anamnesis pediátrica completa · Anamnesis para adultos · Guía de conducción de entrevista · Consentimiento informado · Contrato terapéutico · Ficha de objetivos · Carta de bienvenida',
    value: '$9.000'
  }, {
    num: '05',
    title: 'Banco de Informes Breves, Evoluciones y Devoluciones',
    desc: 'Registro SOAP adaptado a TO · Registro semanal condensado · Evoluciones por diagnóstico (TEA, TDAH, PC, Adulto Mayor) · Derivaciones a especialistas · Informes para docentes y EOE · Devoluciones a familias · Progreso trimestral · Alta y cierre · Banco de frases técnicas',
    value: '$10.000'
  }, {
    num: '06',
    title: 'Manual de Recursos, Derechos y Gestiones para Familias',
    desc: 'Guía completa del CUD paso a paso · Ley 24.901 en lenguaje simple · Cómo reclamar cuando la OS dice no · Modelo de nota de reclamo · Derechos educativos · 10 beneficios disponibles en Argentina 2026 · Directorio de organismos · Glosario de 30 términos · FAQ para familias',
    value: '$7.000'
  }];
  return <section className="py-20 px-4 bg-brand/5 border-y border-brand/20 pt-[25px] pb-[25px]" data-id="element-53">
      <div className="max-w-6xl mx-auto" data-id="element-54">
        <div className="text-center mb-16" data-id="element-55">
          <div className="inline-flex items-center space-x-2 bg-brand text-white px-6 py-2 rounded-full mb-6 font-bold shadow-[0_0_20px_rgba(59,130,246,0.4)]" data-id="element-56">
            <Gift className="w-5 h-5" data-id="element-57" />
            <span data-id="element-58">SIEMPRE INCLUIDOS</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black" data-id="element-59">
            🎁 MÁS LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-gray-400 mt-4 mb-[-29px]" data-id="element-60">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-61">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-6 relative overflow-hidden group hover:border-brand transition-colors" data-id="element-62">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-white/5 group-hover:text-brand/5 transition-colors" data-id="element-63">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-64">
                <div className="text-brand font-bold mb-2" data-id="element-65">
                  Bono {bonus.num}
                </div>
                <h4 className="text-lg font-bold mb-3 text-white leading-tight" data-id="element-66">
                  {bonus.title}
                </h4>
                <p className="text-gray-400 text-sm mb-6" data-id="element-67">{bonus.desc}</p>
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-dark-border" data-id="element-68">
                  <span className="text-gray-500 line-through text-sm" data-id="element-69">
                    Valor {bonus.value}
                  </span>
                  <span className="text-brand font-black" data-id="element-70">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-brand/20 to-brand/5 border border-brand/30 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-71">
          <div className="text-gray-300 mb-2" data-id="element-72">Valor total de los 6 bonos</div>
          <div className="flex items-center justify-center space-x-4" data-id="element-73">
            <span className="text-3xl text-gray-500 line-through font-bold" data-id="element-74">
              $53.000
            </span>
            <span className="md:text-4xl font-black text-brand text-[26px]" data-id="element-75">
              → GRATIS
            </span>
          </div>
          <div className="text-sm text-gray-400 mt-2" data-id="element-76">
            ✅ Incluidos siempre en las dos ofertas
          </div>
        </motion.div>
      </div>
    </section>;
}